import React from "react";

export const LANE_COLORS: Record<string, string> = {
  fast: "bg-green-100 text-green-800",
  io: "bg-blue-100 text-blue-800",
  llm: "bg-purple-100 text-purple-800",
  default: "bg-gray-100 text-gray-800",
};

export const LANE_ORDER = ["fast", "io", "llm", "default"];

export const LaneBadge: React.FC<{ lane: string }> = ({ lane }) => (
  <span
    className={`rounded-full px-2 py-0.5 text-xs font-medium ${LANE_COLORS[lane] ?? LANE_COLORS.default}`}
  >
    {lane}
  </span>
);
